(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[17],{

/***/ "+QRC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var deselectCurrent = __webpack_require__("E9nw");

var clipboardToIE11Formatting = {
  "text/plain": "Text",
  "text/html": "Url",
  "default": "Text"
}

var defaultMessage = "Copy to clipboard: #{key}, Enter";

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug,
    message,
    reselectPrevious,
    range,
    selection,
    mark,
    success = false;
  if (!options) {
    options = {};
  }
  debug = options.debug || false;
  try {
    reselectPrevious = deselectCurrent();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement("span");
    mark.textContent = text;
    // reset user styles for span element
    mark.style.all = "unset";
    // prevents scrolling to the end of the page
    mark.style.position = "fixed";
    mark.style.top = 0;
    mark.style.clip = "rect(0, 0, 0, 0)";
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = "pre";
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = "text";
    mark.style.MozUserSelect = "text";
    mark.style.msUserSelect = "text";
    mark.style.userSelect = "text";
    mark.addEventListener("copy", function(e) {
      e.stopPropagation();
      if (options.format) {
        e.preventDefault();
        if (typeof e.clipboardData === "undefined") { // IE 11
          debug && console.warn("unable to use e.clipboardData");
          debug && console.warn("trying IE specific stuff");
          window.clipboardData.clearData();
          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"]
          window.clipboardData.setData(format, text);
        } else { // all other browsers
          e.clipboardData.clearData();
          e.clipboardData.setData(options.format, text);
        }
      }
      if (options.onCopy) {
        e.preventDefault();
        options.onCopy(e.clipboardData);
      }
    });

    document.body.appendChild(mark);

    range.selectNodeContents(mark);
    selection.addRange(range);

    var successful = document.execCommand("copy");
    if (!successful) {
      throw new Error("copy command was unsuccessful");
    }
    success = true;
  } catch (err) {
    debug && console.error("unable to copy using execCommand: ", err);
    debug && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(options.format || "text", text);
      options.onCopy && options.onCopy(window.clipboardData);
      success = true;
    } catch (err) {
      debug && console.error("unable to copy using clipboardData: ", err);
      debug && console.error("falling back to prompt");
      message = format("message" in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == "function") {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

module.exports = copy;


/***/ }),

/***/ "AINe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("wx14");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zLVn");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prop_types_extra_lib_isRequiredForA11y__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("BO/t");
/* harmony import */ var prop_types_extra_lib_isRequiredForA11y__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types_extra_lib_isRequiredForA11y__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("vUet");






var defaultProps = {
  placement: 'right'
};
var Tooltip = react__WEBPACK_IMPORTED_MODULE_3___default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      placement = _ref.placement,
      className = _ref.className,
      style = _ref.style,
      children = _ref.children,
      arrowProps = _ref.arrowProps,
      _ = _ref.popper,
      _2 = _ref.show,
      props = Object(_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["bsPrefix", "placement", "className", "style", "children", "arrowProps", "popper", "show"]);

  bsPrefix = Object(_ThemeProvider__WEBPACK_IMPORTED_MODULE_5__[/* useBootstrapPrefix */ "a"])(bsPrefix, 'tooltip');

  var _ref2 = (placement == null ? void 0 : placement.split('-')) || [],
      primaryPlacement = _ref2[0];

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("div", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    ref: ref,
    style: style,
    role: "tooltip",
    "x-placement": primaryPlacement,
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, bsPrefix, "bs-tooltip-" + primaryPlacement)
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("div", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    className: "arrow"
  }, arrowProps)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("div", {
    className: bsPrefix + "-inner"
  }, children));
});
Tooltip.defaultProps = defaultProps;
Tooltip.displayName = 'Tooltip';
/* harmony default export */ __webpack_exports__["a"] = (Tooltip);

/***/ }),

/***/ "E9nw":
/***/ (function(module, exports) {


module.exports = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' &&
    selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function(range) {
        selection.addRange(range);
      });
    }

    active &&
    active.focus();
  };
};


/***/ }),

/***/ "dDCJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__("zLVn");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__("dI71");

// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/contains.js
var contains = __webpack_require__("RjgW");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useMounted.js
var useMounted = __webpack_require__("XcHJ");

// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useWillUnmount.js + 1 modules
var useWillUnmount = __webpack_require__("i52p");

// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useTimeout.js



/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */

var MAX_DELAY_MS = Math.pow(2, 31) - 1;

function setChainedTimeout(handleRef, fn, timeoutAtMs) {
  var delayMs = timeoutAtMs - Date.now();
  handleRef.current = delayMs <= MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(function () {
    return setChainedTimeout(handleRef, fn, timeoutAtMs);
  }, MAX_DELAY_MS);
}
/**
 * Returns a controller object for setting a timeout that is properly cleaned up
 * once the component unmounts. New timeouts cancel and replace existing ones.
 */


function useTimeout() {
  var isMounted = Object(useMounted["a" /* default */])(); // types are confused between node and web here IDK

  var handleRef = Object(react["useRef"])();
  Object(useWillUnmount["a" /* default */])(function () {
    return clearTimeout(handleRef.current);
  });
  return Object(react["useMemo"])(function () {
    var clear = function clear() {
      return clearTimeout(handleRef.current);
    };

    function set(fn, delayMs) {
      if (delayMs === void 0) {
        delayMs = 0;
      }

      if (!isMounted()) return;
      clear();

      if (delayMs <= MAX_DELAY_MS) {
        // For simplicity, if the timeout is short, just set a normal timeout.
        handleRef.current = setTimeout(fn, delayMs);
      } else {
        setChainedTimeout(handleRef, fn, Date.now() + delayMs);
      }
    }

    return {
      set: set,
      clear: clear
    };
  }, []);
}
// EXTERNAL MODULE: ./node_modules/react-overlays/esm/safeFindDOMNode.js
var safeFindDOMNode = __webpack_require__("B8pp");

// EXTERNAL MODULE: ./node_modules/warning/warning.js
var warning = __webpack_require__("2W6z");

// EXTERNAL MODULE: ./node_modules/uncontrollable/esm/index.js + 4 modules
var esm = __webpack_require__("JCAc");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./node_modules/react-overlays/node_modules/@babel/runtime/helpers/esm/extends.js
var helpers_esm_extends = __webpack_require__("du3w");

// EXTERNAL MODULE: ./node_modules/react-overlays/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var esm_objectWithoutPropertiesLoose = __webpack_require__("yp5u");

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__("17x9");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__("i8i4");
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useCallbackRef.js
var useCallbackRef = __webpack_require__("7A6N");

// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useMergedRefs.js
var useMergedRefs = __webpack_require__("lcWJ");

// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/enums.js
var enums = __webpack_require__("d/mp");

// EXTERNAL MODULE: ./node_modules/react-overlays/esm/usePopper.js + 1 modules
var usePopper = __webpack_require__("RcA9");

// EXTERNAL MODULE: ./node_modules/react-overlays/esm/useRootClose.js + 1 modules
var useRootClose = __webpack_require__("+JL2");

// EXTERNAL MODULE: ./node_modules/react-overlays/esm/useWaitForDOMRef.js
var useWaitForDOMRef = __webpack_require__("knGs");

// EXTERNAL MODULE: ./node_modules/react-overlays/esm/mergeOptionsWithPopperConfig.js
var mergeOptionsWithPopperConfig = __webpack_require__("QxbT");

// CONCATENATED MODULE: ./node_modules/react-overlays/esm/Overlay.js













/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */
var Overlay = /*#__PURE__*/react_default.a.forwardRef(function (props, outerRef) {
  var flip = props.flip,
      offset = props.offset,
      placement = props.placement,
      _props$containerPaddi = props.containerPadding,
      containerPadding = _props$containerPaddi === void 0 ? 5 : _props$containerPaddi,
      _props$popperConfig = props.popperConfig,
      popperConfig = _props$popperConfig === void 0 ? {} : _props$popperConfig,
      Transition = props.transition;

  var _useCallbackRef = Object(useCallbackRef["a" /* default */])(),
      rootElement = _useCallbackRef[0],
      attachRef = _useCallbackRef[1];

  var _useCallbackRef2 = Object(useCallbackRef["a" /* default */])(),
      arrowElement = _useCallbackRef2[0],
      attachArrowRef = _useCallbackRef2[1];

  var mergedRef = Object(useMergedRefs["a" /* default */])(attachRef, outerRef);
  var container = Object(useWaitForDOMRef["a" /* default */])(props.container);
  var target = Object(useWaitForDOMRef["a" /* default */])(props.target);

  var _useState = Object(react["useState"])(!props.show),
      exited = _useState[0],
      setExited = _useState[1];

  var _usePopper = Object(usePopper["a" /* default */])(target, rootElement, Object(mergeOptionsWithPopperConfig["a" /* default */])({
    placement: placement,
    enableEvents: !!props.show,
    containerPadding: containerPadding || 5,
    flip: flip,
    offset: offset,
    arrowElement: arrowElement,
    popperConfig: popperConfig
  })),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes,
      popper = Object(esm_objectWithoutPropertiesLoose["a" /* default */])(_usePopper, ["styles", "attributes"]);

  if (props.show) {
    if (exited) setExited(false);
  } else if (!props.transition && !exited) {
    setExited(true);
  }

  var handleHidden = function handleHidden() {
    setExited(true);

    if (props.onExited) {
      props.onExited.apply(props, arguments);
    }
  }; // Don't un-render the overlay while it's transitioning out.


  var mountOverlay = props.show || Transition && !exited;
  Object(useRootClose["a" /* default */])(rootElement, props.onHide, {
    disabled: !props.rootClose || props.rootCloseDisabled,
    clickTrigger: props.rootCloseEvent
  });

  if (!mountOverlay) {
    // Don't bother showing anything if we don't have to.
    return null;
  }

  var child = props.children(Object(helpers_esm_extends["a" /* default */])({}, popper, {
    show: !!props.show,
    props: Object(helpers_esm_extends["a" /* default */])({}, attributes.popper, {
      style: styles.popper,
      ref: mergedRef
    }),
    arrowProps: Object(helpers_esm_extends["a" /* default */])({}, attributes.arrow, {
      style: styles.arrow,
      ref: attachArrowRef
    })
  }));

  if (Transition) {
    var onExit = props.onExit,
        onExiting = props.onExiting,
        onEnter = props.onEnter,
        onEntering = props.onEntering,
        onEntered = props.onEntered;
    child = /*#__PURE__*/react_default.a.createElement(Transition, {
      "in": props.show,
      appear: true,
      onExit: onExit,
      onExiting: onExiting,
      onExited: handleHidden,
      onEnter: onEnter,
      onEntering: onEntering,
      onEntered: onEntered
    }, child);
  }

  return container ? /*#__PURE__*/react_dom_default.a.createPortal(child, container) : null;
});
Overlay.displayName = 'Overlay';
Overlay.propTypes = {
  /**
   * Set the visibility of the Overlay
   */
  show: prop_types_default.a.bool,

  /** Specify where the overlay element is positioned in relation to the target element */
  placement: prop_types_default.a.oneOf(enums["h" /* placements */]),

  /**
   * A DOM Element, Ref to an element, or function that returns either. The `target` element is where
   * the overlay is positioned relative to.
   */
  target: prop_types_default.a.any,

  /**
   * A DOM Element, Ref to an element, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: prop_types_default.a.any,

  /**
   * Enables the Popper.js `flip` modifier, allowing the Overlay to
   * automatically adjust it's placement in case of overlap with the viewport or toggle.
   * Refer to the [flip docs](https://popper.js.org/popper-documentation.html#modifiers..flip.enabled) for more info
   */
  flip: prop_types_default.a.bool,

  /**
   * A render prop that returns an element to overlay and position. See
   * the [react-popper documentation](https://github.com/FezVrasta/react-popper#children) for more info.
   *
   * @type {Function ({
   *   show: boolean,
   *   placement: Placement,
   *   update: () => void,
   *   forceUpdate: () => void,
   *   props: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *     aria-labelledby: ?string
   *     [string]: string | number,
   *   },
   *   arrowProps: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *     [string]: string | number,
   *   },
   * }) => React.Element}
   */
  children: prop_types_default.a.func.isRequired,

  /**
   * Control how much space there is between the edge of the boundary element and overlay.
   * A convenience shortcut to setting `popperConfig.modfiers.preventOverflow.padding`
   */
  containerPadding: prop_types_default.a.number,

  /**
   * A set of popper options and props passed directly to react-popper's Popper component.
   */
  popperConfig: prop_types_default.a.object,

  /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */
  rootClose: prop_types_default.a.bool,

  /**
   * Specify event for toggling overlay
   */
  rootCloseEvent: prop_types_default.a.oneOf(['click', 'mousedown']),

  /**
   * Specify disabled for disable RootCloseWrapper
   */
  rootCloseDisabled: prop_types_default.a.bool,

  /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */
  onHide: function onHide(props) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (props.rootClose) {
      var _PropTypes$func;

      return (_PropTypes$func = prop_types_default.a.func).isRequired.apply(_PropTypes$func, [props].concat(args));
    }

    return prop_types_default.a.func.apply(prop_types_default.a, [props].concat(args));
  },

  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component
   * used to animate the overlay as it changes visibility.
   */
  // @ts-ignore
  transition: prop_types_default.a.elementType,

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: prop_types_default.a.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: prop_types_default.a.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: prop_types_default.a.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: prop_types_default.a.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: prop_types_default.a.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: prop_types_default.a.func
};
/* harmony default export */ var esm_Overlay = (Overlay);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/usePopperMarginModifiers.js
var usePopperMarginModifiers = __webpack_require__("VwLC");

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Fade.js + 4 modules
var Fade = __webpack_require__("7xGa");

// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Overlay.js








var defaultProps = {
  transition: Fade["a" /* default */],
  rootClose: false,
  show: false,
  placement: 'top'
};

function wrapRefs(props, arrowProps) {
  var ref = props.ref;
  var aRef = arrowProps.ref;

  props.ref = ref.__wrapped || (ref.__wrapped = function (r) {
    return ref(Object(safeFindDOMNode["a" /* default */])(r));
  });

  arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = function (r) {
    return aRef(Object(safeFindDOMNode["a" /* default */])(r));
  });
}

function Overlay_Overlay(_ref) {
  var overlay = _ref.children,
      transition = _ref.transition,
      _ref$popperConfig = _ref.popperConfig,
      popperConfig = _ref$popperConfig === void 0 ? {} : _ref$popperConfig,
      outerProps = Object(objectWithoutPropertiesLoose["a" /* default */])(_ref, ["children", "transition", "popperConfig"]);

  var popperRef = Object(react["useRef"])({});

  var _usePopperMarginModif = Object(usePopperMarginModifiers["a" /* default */])(),
      ref = _usePopperMarginModif[0],
      marginModifiers = _usePopperMarginModif[1];

  var actualTransition = transition === true ? Fade["a" /* default */] : transition || null;
  return /*#__PURE__*/react_default.a.createElement(esm_Overlay, Object(esm_extends["a" /* default */])({}, outerProps, {
    ref: ref,
    popperConfig: Object(esm_extends["a" /* default */])({}, popperConfig, {
      modifiers: marginModifiers.concat(popperConfig.modifiers || [])
    }),
    transition: actualTransition
  }), function (_ref2) {
    var _state$modifiersData$;

    var overlayProps = _ref2.props,
        arrowProps = _ref2.arrowProps,
        show = _ref2.show,
        update = _ref2.update,
        _ = _ref2.forceUpdate,
        placement = _ref2.placement,
        state = _ref2.state,
        props = Object(objectWithoutPropertiesLoose["a" /* default */])(_ref2, ["props", "arrowProps", "show", "update", "forceUpdate", "placement", "state"]);

    wrapRefs(overlayProps, arrowProps);
    var popper = Object.assign(popperRef.current, {
      state: state,
      scheduleUpdate: update,
      placement: placement,
      outOfBoundaries: (state == null ? void 0 : (_state$modifiersData$ = state.modifiersData.hide) == null ? void 0 : _state$modifiersData$.isReferenceHidden) || false
    });
    if (typeof overlay === 'function') return overlay(Object(esm_extends["a" /* default */])({}, props, {}, overlayProps, {
      placement: placement,
      show: show,
      popper: popper,
      arrowProps: arrowProps
    }));
    return react_default.a.cloneElement(overlay, Object(esm_extends["a" /* default */])({}, props, {}, overlayProps, {
      placement: placement,
      arrowProps: arrowProps,
      popper: popper,
      className: classnames_default()(overlay.props.className, !transition && show && 'show'),
      style: Object(esm_extends["a" /* default */])({}, overlay.props.style, {}, overlayProps.style)
    }));
  });
}

Overlay_Overlay.defaultProps = defaultProps;
/* harmony default export */ var react_bootstrap_esm_Overlay = (Overlay_Overlay);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/OverlayTrigger.js











var OverlayTrigger_RefHolder = /*#__PURE__*/function (_React$Component) {
  Object(inheritsLoose["a" /* default */])(RefHolder, _React$Component);

  function RefHolder() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = RefHolder.prototype;

  _proto.render = function render() {
    return this.props.children;
  };

  return RefHolder;
}(react_default.a.Component);

function normalizeDelay(delay) {
  return delay && typeof delay === 'object' ? delay : {
    show: delay,
    hide: delay
  };
} // Simple implementation of mouseEnter and mouseLeave.
// React's built version is broken: https://github.com/facebook/react/issues/4251
// for cases when the trigger is disabled and mouseOut/Over can cause flicker
// moving from one child element to another.


function handleMouseOverOut(handler, args, relatedNative) {
  var e = args[0];
  var target = e.currentTarget;
  var related = e.relatedTarget || e.nativeEvent[relatedNative];

  if ((!related || related !== target) && !Object(contains["a" /* default */])(target, related)) {
    handler.apply(void 0, args);
  }
}

var OverlayTrigger_defaultProps = {
  defaultShow: false,
  trigger: ['hover', 'focus']
};

function OverlayTrigger(_ref) {
  var trigger = _ref.trigger,
      overlay = _ref.overlay,
      children = _ref.children,
      _ref$popperConfig = _ref.popperConfig,
      popperConfig = _ref$popperConfig === void 0 ? {} : _ref$popperConfig,
      propsShow = _ref.show,
      _ref$defaultShow = _ref.defaultShow,
      defaultShow = _ref$defaultShow === void 0 ? false : _ref$defaultShow,
      onToggle = _ref.onToggle,
      propsDelay = _ref.delay,
      placement = _ref.placement,
      _ref$flip = _ref.flip,
      flip = _ref$flip === void 0 ? placement && placement.indexOf('auto') !== -1 : _ref$flip,
      props = Object(objectWithoutPropertiesLoose["a" /* default */])(_ref, ["trigger", "overlay", "children", "popperConfig", "show", "defaultShow", "onToggle", "delay", "placement", "flip"]);

  var triggerNodeRef = Object(react["useRef"])(null);
  var timeout = useTimeout();
  var hoverStateRef = Object(react["useRef"])('');

  var _useUncontrolledProp = Object(esm["b" /* useUncontrolledProp */])(propsShow, defaultShow, onToggle),
      show = _useUncontrolledProp[0],
      setShow = _useUncontrolledProp[1];

  var delay = normalizeDelay(propsDelay);

  var _ref2 = typeof children !== 'function' ? react_default.a.Children.only(children).props : {},
      onFocus = _ref2.onFocus,
      onBlur = _ref2.onBlur,
      onClick = _ref2.onClick;

  var getTarget = Object(react["useCallback"])(function () {
    return Object(safeFindDOMNode["a" /* default */])(triggerNodeRef.current);
  }, []);
  var handleShow = Object(react["useCallback"])(function () {
    timeout.clear();
    hoverStateRef.current = 'show';

    if (!delay.show) {
      setShow(true);
      return;
    }

    timeout.set(function () {
      if (hoverStateRef.current === 'show') setShow(true);
    }, delay.show);
  }, [delay.show, setShow, timeout]);
  var handleHide = Object(react["useCallback"])(function () {
    timeout.clear();
    hoverStateRef.current = 'hide';

    if (!delay.hide) {
      setShow(false);
      return;
    }

    timeout.set(function () {
      if (hoverStateRef.current === 'hide') setShow(false);
    }, delay.hide);
  }, [delay.hide, setShow, timeout]);
  var handleFocus = Object(react["useCallback"])(function () {
    handleShow();

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    onFocus == null ? void 0 : onFocus.apply(void 0, args);
  }, [handleShow, onFocus]);
  var handleBlur = Object(react["useCallback"])(function () {
    handleHide();

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    onBlur == null ? void 0 : onBlur.apply(void 0, args);
  }, [handleHide, onBlur]);
  var handleClick = Object(react["useCallback"])(function () {
    setShow(!show);
    if (onClick) onClick.apply(void 0, arguments);
  }, [onClick, setShow, show]);
  var handleMouseOver = Object(react["useCallback"])(function () {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    handleMouseOverOut(handleShow, args, 'fromElement');
  }, [handleShow]);
  var handleMouseOut = Object(react["useCallback"])(function () {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    handleMouseOverOut(handleHide, args, 'toElement');
  }, [handleHide]);
  var triggers = trigger == null ? [] : [].concat(trigger);
  var triggerProps = {};

  if (triggers.indexOf('click') !== -1) {
    triggerProps.onClick = handleClick;
  }

  if (triggers.indexOf('focus') !== -1) {
    triggerProps.onFocus = handleFocus;
    triggerProps.onBlur = handleBlur;
  }

  if (triggers.indexOf('hover') !== -1) {
     false ? undefined : void 0;
    triggerProps.onMouseOver = handleMouseOver;
    triggerProps.onMouseOut = handleMouseOut;
  }

  return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, typeof children === 'function' ? children(Object(esm_extends["a" /* default */])({}, triggerProps, {
    ref: triggerNodeRef
  })) : /*#__PURE__*/react_default.a.createElement(OverlayTrigger_RefHolder, {
    ref: triggerNodeRef
  }, Object(react["cloneElement"])(children, triggerProps)), /*#__PURE__*/react_default.a.createElement(react_bootstrap_esm_Overlay, Object(esm_extends["a" /* default */])({}, props, {
    show: show,
    onHide: handleHide,
    flip: flip,
    placement: placement,
    popperConfig: popperConfig,
    target: getTarget
  }), overlay));
}

OverlayTrigger.defaultProps = OverlayTrigger_defaultProps;
/* harmony default export */ var esm_OverlayTrigger = __webpack_exports__["a"] = (OverlayTrigger);

/***/ }),

/***/ "dDby":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SHOW_GLOBAL_ALERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HIDE_GLOBAL_ALERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return showGlobalAlert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hideGlobalAlert; });
var SHOW_GLOBAL_ALERT = 'globalAlert/SHOW_GLOBAL_ALERT';
var HIDE_GLOBAL_ALERT = 'globalAlert/HIDE_GLOBAL_ALERT';

function showGlobalAlert(alert) {
  return {
    type: SHOW_GLOBAL_ALERT,
    alert: alert
  };
}

function hideGlobalAlert() {
  return {
    type: HIDE_GLOBAL_ALERT
  };
}



/***/ }),

/***/ "ePSK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DOCUMENT_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VIEWER_STATUS_DESKTOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return VIEWER_STATUS_TABLET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VIEWER_STATUS_MOBILE; });
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("mOvS");
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_0__);


var _getConfig = next_config__WEBPACK_IMPORTED_MODULE_0___default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var protocol = publicRuntimeConfig.PROTOCOL;
var spaHost = publicRuntimeConfig.SPA_HOST;
var DOCUMENT_DOMAIN = "".concat(protocol, "://").concat(spaHost, "/");
var VIEWER_STATUS_DESKTOP = 'desktop_viewer';
var VIEWER_STATUS_TABLET = 'tablet_viewer';
var VIEWER_STATUS_MOBILE = 'mobile_viewer';

/***/ }),

/***/ "xC9x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_DOCUMENTS_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_DOCUMENTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_DOCUMENTS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_DOCUMENT_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CREATE_DOCUMENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_DOCUMENT_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return RENAME_DOCUMENT_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return RENAME_DOCUMENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return RENAME_DOCUMENT_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return REMOVE_DOCUMENT_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return REMOVE_DOCUMENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return REMOVE_DOCUMENT_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DUPLICATE_DOCUMENT_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DUPLICATE_DOCUMENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DUPLICATE_DOCUMENT_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PUBLISH_DOCUMENT_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return PUBLISH_DOCUMENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PUBLISH_DOCUMENT_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return UNPUBLISH_DOCUMENT_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return UNPUBLISH_DOCUMENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return UNPUBLISH_DOCUMENT_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return UPDATE_DOCUMENT_CONFIG_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return UPDATE_DOCUMENT_CONFIG_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return UPDATE_DOCUMENT_CONFIG_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return fetchDocuments; });
/* unused harmony export fetchDocumentsSuccess */
/* unused harmony export fetchDocumentsFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return createDocument; });
/* unused harmony export createDocumentSuccess */
/* unused harmony export createDocumentFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return renameDocument; });
/* unused harmony export renameDocumentSuccess */
/* unused harmony export renameDocumentFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return removeDocument; });
/* unused harmony export removeDocumentSuccess */
/* unused harmony export removeDocumentFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return duplicateDocument; });
/* unused harmony export duplicateDocumentSuccess */
/* unused harmony export duplicateDocumentFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return publishDocument; });
/* unused harmony export publishDocumentSuccess */
/* unused harmony export publishDocumentFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return unpublishDocument; });
/* unused harmony export unpublishDocumentSuccess */
/* unused harmony export unpublishDocumentFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return updateDocumentConfig; });
/* unused harmony export updateDocumentConfigSuccess */
/* unused harmony export updateDocumentConfigFailed */
var FETCH_DOCUMENTS_REQUESTED = 'document/FETCH_DOCUMENTS_REQUESTED';
var FETCH_DOCUMENTS_SUCCESS = 'document/FETCH_DOCUMENTS_SUCCESS';
var FETCH_DOCUMENTS_FAILED = 'document/FETCH_DOCUMENTS_FAILED';
var CREATE_DOCUMENT_REQUESTED = 'document/CREATE_DOCUMENT_REQUESTED';
var CREATE_DOCUMENT_SUCCESS = 'document/CREATE_DOCUMENT_SUCCESS';
var CREATE_DOCUMENT_FAILED = 'document/CREATE_DOCUMENT_FAILED';
var RENAME_DOCUMENT_REQUESTED = 'document/RENAME_DOCUMENT_REQUESTED';
var RENAME_DOCUMENT_SUCCESS = 'document/RENAME_DOCUMENT_SUCCESS';
var RENAME_DOCUMENT_FAILED = 'document/RENAME_DOCUMENT_FAILED';
var REMOVE_DOCUMENT_REQUESTED = 'document/REMOVE_DOCUMENT_REQUESTED';
var REMOVE_DOCUMENT_SUCCESS = 'document/REMOVE_DOCUMENT_SUCCESS';
var REMOVE_DOCUMENT_FAILED = 'document/REMOVE_DOCUMENT_FAILED';
var DUPLICATE_DOCUMENT_REQUESTED = 'document/DUPLICATE_DOCUMENT_REQUESTED';
var DUPLICATE_DOCUMENT_SUCCESS = 'document/DUPLICATE_DOCUMENT_SUCCESS';
var DUPLICATE_DOCUMENT_FAILED = 'document/DUPLICATE_DOCUMENT_FAILED';
var PUBLISH_DOCUMENT_REQUESTED = 'document/PUBLISH_DOCUMENT_REQUESTED';
var PUBLISH_DOCUMENT_SUCCESS = 'document/PUBLISH_DOCUMENT_SUCCESS';
var PUBLISH_DOCUMENT_FAILED = 'document/PUBLISH_DOCUMENT_FAILED';
var UNPUBLISH_DOCUMENT_REQUESTED = 'document/UNPUBLISH_DOCUMENT_REQUESTED';
var UNPUBLISH_DOCUMENT_SUCCESS = 'document/UNPUBLISH_DOCUMENT_SUCCESS';
var UNPUBLISH_DOCUMENT_FAILED = 'document/UNPUBLISH_DOCUMENT_FAILED';
var UPDATE_DOCUMENT_CONFIG_REQUESTED = 'document/UPDATE_DOCUMENT_CONFIG_REQUESTED';
var UPDATE_DOCUMENT_CONFIG_SUCCESS = 'document/UPDATE_DOCUMENT_CONFIG_SUCCESS';
var UPDATE_DOCUMENT_CONFIG_FAILED = 'document/UPDATE_DOCUMENT_CONFIG_FAILED';

function fetchDocuments() {
  return {
    type: FETCH_DOCUMENTS_REQUESTED
  };
}

function fetchDocumentsSuccess(documents) {
  return {
    type: FETCH_DOCUMENTS_SUCCESS,
    documents: documents
  };
}

function fetchDocumentsFailed() {
  return {
    type: FETCH_DOCUMENTS_FAILED
  };
}

function createDocument(_ref) {
  var templateId = _ref.templateId,
      templatesData = _ref.templatesData,
      router = _ref.router;
  return {
    type: CREATE_DOCUMENT_REQUESTED,
    templateId: templateId,
    templatesData: templatesData,
    router: router
  };
}

function createDocumentSuccess(newDocument) {
  return {
    type: CREATE_DOCUMENT_SUCCESS,
    newDocument: newDocument
  };
}

function createDocumentFailed() {
  return {
    type: CREATE_DOCUMENT_FAILED
  };
}

function renameDocument(_ref2) {
  var path = _ref2.path,
      title = _ref2.title;
  return {
    type: RENAME_DOCUMENT_REQUESTED,
    path: path,
    title: title
  };
}

function renameDocumentSuccess(_ref3) {
  var path = _ref3.path,
      title = _ref3.title;
  return {
    type: RENAME_DOCUMENT_SUCCESS,
    path: path,
    title: title
  };
}

function renameDocumentFailed() {
  return {
    type: RENAME_DOCUMENT_FAILED
  };
}

function removeDocument(_ref4) {
  var path = _ref4.path;
  return {
    type: REMOVE_DOCUMENT_REQUESTED,
    path: path
  };
}

function removeDocumentSuccess() {
  return {
    type: REMOVE_DOCUMENT_SUCCESS
  };
}

function removeDocumentFailed() {
  return {
    type: REMOVE_DOCUMENT_FAILED
  };
}

function duplicateDocument(_ref5) {
  var path = _ref5.path;
  return {
    type: DUPLICATE_DOCUMENT_REQUESTED,
    path: path
  };
}

function duplicateDocumentSuccess(_ref6) {
  var duplicatedDocument = _ref6.duplicatedDocument;
  return {
    type: DUPLICATE_DOCUMENT_SUCCESS,
    duplicatedDocument: duplicatedDocument
  };
}

function duplicateDocumentFailed() {
  return {
    type: DUPLICATE_DOCUMENT_FAILED
  };
}

function publishDocument(_ref7) {
  var path = _ref7.path,
      router = _ref7.router;
  return {
    type: PUBLISH_DOCUMENT_REQUESTED,
    path: path,
    router: router
  };
}

function publishDocumentSuccess() {
  return {
    type: PUBLISH_DOCUMENT_SUCCESS
  };
}

function publishDocumentFailed() {
  return {
    type: PUBLISH_DOCUMENT_FAILED
  };
}

function unpublishDocument(_ref8) {
  var path = _ref8.path;
  return {
    type: UNPUBLISH_DOCUMENT_REQUESTED,
    path: path
  };
}

function unpublishDocumentSuccess(_ref9) {
  var path = _ref9.path,
      published = _ref9.published;
  return {
    type: UNPUBLISH_DOCUMENT_SUCCESS,
    path: path,
    published: published
  };
}

function unpublishDocumentFailed() {
  return {
    type: UNPUBLISH_DOCUMENT_FAILED
  };
}

function updateDocumentConfig(_ref10) {
  var path = _ref10.path,
      newPath = _ref10.newPath,
      open_to_public = _ref10.open_to_public;
  return {
    type: UPDATE_DOCUMENT_CONFIG_REQUESTED,
    path: path,
    newPath: newPath,
    open_to_public: open_to_public
  };
}

function updateDocumentConfigSuccess(_ref11) {
  var path = _ref11.path,
      newPath = _ref11.newPath,
      open_to_public = _ref11.open_to_public;
  return {
    type: UPDATE_DOCUMENT_CONFIG_SUCCESS,
    path: path,
    newPath: newPath,
    open_to_public: open_to_public
  };
}

function updateDocumentConfigFailed() {
  return {
    type: UPDATE_DOCUMENT_CONFIG_FAILED
  };
}



/***/ }),

/***/ "xrJA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export meShape */
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("17x9");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

var meShape = prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.shape({
  id: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number.isRequired,
  avatar: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  email: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  username: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  first_name: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
  last_name: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired
});

/***/ })

}]);